// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"72c620ac","406":"81ea1615","488":"86bb584e","543":"587c393b","620":"8c3d7967","671":"af2c7da6","691":"8cf4fe65","693":"388fb196","701":"758d4347","713":"60396b2e","746":"d1252060","764":"da221250","853":"c81bbb61"}[chunkId] + ".chunk.js";
};